/* eslint-disable consistent-return */
import {
  Button,
  Grid,
  InputAdornment,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import {
  connectABusinessPartner,
  getBusinessSearch,
  getSchoolsPartners,
  getBusinessesDomains,
  getSchoolSectors,
} from '@webapps/business';
import {
  Modal,
  FormikTextField,
  FormikAutocompletePx,
  Loader,
  Pagination,
  useAuth,
  useMutation,
  useQuery,
  useRouter,
  useToast,
  PaginationNumbers,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import ConfirmDialog from 'components/ConfirmDialog';
import { ROUTES_PATH } from 'config/constants';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import AddPartnerCard from './AddPartnerCard';
import AddExternalPartner from './AddExternalPartner';

const AddPartner = ({ refetch }) => {
  const {
    css,
    classes,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(3);
  const [openExternalPartner, setOpenExternalPartner] = useState(false);

  const [keywordRequest, setKeywordRequest] = useState('');
  const [domainRequest, setDomainRequest] = useState('');
  const [sectorRequest, setSectorRequest] = useState('');
  const [errorExist, setErrorExist] = useState(false);

  const [idSelect, setIdSelect] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleOpenConfirmDialog = (id) => {
    setIdSelect(id);
    setOpenConfirm(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirm(false);
  };

  const {
    status: load,
    data: { content: businesses = [], totalElements } = {},
    isFetching,
    refetch: refetchBusiness,
  } = useQuery(getBusinessSearch, {
    key: ['searchBusinessForPartner', keywordRequest + sectorRequest + domainRequest + idUser + page],
    variables: {
      keyword: keywordRequest,
      sectors: sectorRequest,
      domains: domainRequest,
      schoolId: idUser,
      page: page - 1,
      size,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const {
    isLoading: isLoadingConnect,
    isSuccess: isSuccessConnect,
    mutateAsync: mutateConnect,
  } = useMutation(connectABusinessPartner);

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const { push } = useRouter();
  const { addToast } = useToast();

  useEffect(() => {
    if (isSuccessConnect) {
      addToast({
        status: 'success',
        message: 'Demande envoyée',
      });
      handleCloseConfirmDialog();
      refetch();
      refetchBusiness();
      formik.resetForm();
    }
  }, [isSuccessConnect]);

  const formik = useFormik({
    initialValues: {
      keyword: '',
      domains: [],
      sectors: []
    },
    onSubmit: ({ keyword }) => {
      setKeywordRequest(keyword);
      setDomainRequest(formik.values?.domains?.map((value) => value).join());
      setSectorRequest(formik.values?.sectors?.map((value) => value).join());
      setPage(1);
    },
  });

  const viewPartner = (id) => {
    push(ROUTES_PATH.BUSINESS_VITRINE, { params: { id } });
  };

  const { data: { content: mypartnersAccepted = [] } = {} } = useQuery(
    getSchoolsPartners,
    {
      key: ['schoolsPartnersAccepted', page],
      variables: {
        id: idUser,
        type: 'accepted',
        page: page - 1,
        size: 1000,
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const { data: { content: mypartnersReceived = [] } = {} } = useQuery(
    getSchoolsPartners,
    {
      key: ['schoolsPartnersReceived', page],
      variables: {
        id: idUser,
        type: 'received',
        page: page - 1,
        size: 1000,
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const { data: { content: mypartnersRequested = [] } = {} } = useQuery(
    getSchoolsPartners,
    {
      key: ['schoolsPartnersRequested', page],
      variables: {
        id: idUser,
        type: 'requested',
        page: page - 1,
        size: 1000,
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const { data: domains = [] } = useQuery(getBusinessesDomains, {
    key: 'domainsBusiness',
  });

  const { data: sectors = [] } = useQuery(getSchoolSectors, {
    key: 'allSectorsSchools',
  });

  const reqPartner = async (id) => {
    const allPartners = [
      ...mypartnersAccepted,
      ...mypartnersReceived,
      ...mypartnersRequested,
    ];
    if (
      allPartners.filter(({ id: idPartnerExist }) => idPartnerExist === id) <= 0
    ) {
      setErrorExist(false);
      await mutateConnect({
        data: {
          schoolId: idUser,
          businessId: id,
        },
      });
    } else {
      handleCloseConfirmDialog();
      setErrorExist(true);
      refetch();
      refetchBusiness();
      formik.resetForm();
    }
  };

  useEffect(() => {
    if (formik.values) {
      formik.handleSubmit();
    }
  }, [formik.values]);

  return (
    <div>
      <Grid
        container
        className={css({
          marginTop: 18,
          marginBottom: 24,
          columnGap: 10,
          '@media screen and (max-width: 1023px)': {
            flexDirection: 'column',
            rowGap: 10,
          },
        })}
      >
        <Grid item xs>
          <FormikTextField
            formik={formik}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search style={{ color: '#5D75A8' }} />
                </InputAdornment>
              ),
            }}
            className={classes.btn}
            label={"Nom de l'entreprise"}
            name="keyword"
          />
        </Grid>
        <Grid item xs>
          <FormikAutocompletePx
            formik={formik}
            fullWidth
            getOptionLabel={(option) => option.label || ''}
            label="Domaines pro. (Offres d'emploi)"
            multiple
            name="domains"
            options={domains}
            pathValue="id"
            value={domains?.filter(({ id }) =>
              formik?.values?.domains?.includes(id)
            )}
          />
        </Grid>
        <Grid item xs>
          <FormikAutocompletePx
            formik={formik}
            fullWidth
            getOptionLabel={(option) => option.label || ''}
            label="Secteur(s) d'activité(s)"
            multiple
            name="sectors"
            options={sectors}
            pathValue="id"
            value={sectors?.filter(({ id }) =>
              formik?.values?.sectors?.includes(id)
            )}
          />
        </Grid>
        <Grid item xs>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            disableElevation
            className={classes.button}
            onClick={() => setOpenExternalPartner(true)}
          >
            Ajouter une entreprise externe
          </Button>
        </Grid>
      </Grid>
      {errorExist && (
        <div className={css({ color: 'red' })}>
          Vous êtes déjà partenaire avec cet organisme ou en attente de
          validation
        </div>
      )}
      {businesses?.length > 0 ? (
        <Grid
          className={classes.PartenerCardContainer}
          container
          spacing={3}
          style={{
            backgroundColor: '#F3F7FF',
            position: 'relative',
            borderRadius: 20,
            padding: 8,
            rowGap: 20,
            marginBottom: spacing(2.5),
          }}
        >
        {isFetching && (
          <div className={global.loader}>
            <Loader />
          </div>
        )}
        {businesses?.map(({ account, address, id, name, sector }) => (
          <AddPartnerCard
            account={account}
            address={address}
            refetch={refetch}
            id={id}
            name={name}
            sector={sector}
            handleOpenConfirmDialog={handleOpenConfirmDialog}
          />
        ))}
      </Grid>
      ) : (
        <div className={css({ textAlign: 'center' })}>
          <p>Aucun résultat trouvé</p>
        </div>
      )}
      <PaginationNumbers
        onChange={handlePaginationChange}
        page={page}
        pageCount={size}
        totalCount={totalElements}
      />

      <ConfirmDialog
        confirm={() => reqPartner(idSelect)}
        handleCloseConfirmDialog={handleCloseConfirmDialog}
        isLoadingConfirm={isLoadingConnect}
        openConfirm={openConfirm}
        title="Confirmez-vous ?"
      ></ConfirmDialog>
      <Modal
        onCancel={() => setOpenExternalPartner(false)}
        open={openExternalPartner}
        title="Ajouter une entreprise externe"
        width="800px"
      >
        <AddExternalPartner
          onClose={() => setOpenExternalPartner(false)}
          refetch={refetch}
        />
      </Modal>
    </div>
  );
};

AddPartner.propTypes = {
  refetch: PropTypes.func,
};

const styles = ({ spacing }) => ({
  cardContainer: {
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
    height: '100%',
    padding: 20,
  },
  PartenerCardContainer: {
    margin: 0,
    width: '100%',
    '@media screen and (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  nameAdressDiv: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 10,
  },
  avatar: {
    height: 80,
    width: 80,
  },
});

export default AddPartner;